// TODO: Ideally these logics should be in the back

import type {
  SolidarizedMaterial,
  SolidarizedMaterialsType,
} from "./materialCharacteristics.types";

export const NON_PRECIOUS_METAL_MATERIALS = [
  "PFM_NON_PRECIOUS",
  "METAL_NON_PRECIOUS",
] as const;

export const ZIRCONIA_MATERIALS = [
  "PORCELAIN_FUSED_ZIRCONIA",
  "ZIRCONIA_FULL",
] as const;

export const solidarizedMaterialsTypesEnum: Record<
  SolidarizedMaterialsType,
  SolidarizedMaterialsType
> = {
  NON_PRECIOUS_METAL_MATERIALS: "NON_PRECIOUS_METAL_MATERIALS",
  ZIRCONIA_MATERIALS: "ZIRCONIA_MATERIALS",
} as const;

export const SOLIDARIZED_MATERIALS: Array<SolidarizedMaterial> = [
  {
    type: "NON_PRECIOUS_METAL_MATERIALS",
    materials: NON_PRECIOUS_METAL_MATERIALS,
  },
  {
    type: "ZIRCONIA_MATERIALS",
    materials: ZIRCONIA_MATERIALS,
  },
] as const;
